<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Favourites",
      text: "Customer",
      text1: "Favourites",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer/favourites");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Favorites</h4>
              <div class="d-flex align-items-center">
                <span class="text-dark me-2">Sort</span>
                <div class="dropdown me-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle bg-light-300"
                    data-bs-toggle="dropdown"
                  >
                    Newly Added
                  </a>
                  <div class="dropdown-menu">
                    <a href="javascript:void(0);" class="dropdown-item active"
                      >Recently Added</a
                    >
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded me-2"
                  ><i class="ti ti-calendar"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded"
                  ><i class="ti ti-adjustments-alt"></i
                ></a>
              </div>
            </div>
            <div class="row justify-content-center align-items-center">
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-13.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Car Wash</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Car Repair Services</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-01.jpg"
                              class="img-fluid rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div class="user-id">
                            <h6 class="fs-14">John Smith</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>New Jersey,USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm">
                            View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0 w-100">
                  <div class="card-body p-0">
                    <div class="img-sec-2">
                      <a href="javascript:void(0);"
                        ><img
                          src="@/assets/img/providers/provider-14.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></a>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Construction</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Toughened Glass Fitting Services</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-02.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-16">Charles</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>Chicago, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-15.jpg"
                          class="rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Construction</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Computer & Server AMC Service</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-03.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Wilfredo</h6>
                            <span class="fs-12 text-truncate"
                              ><i class="ti ti-map-pin me-1"></i>Los Angeles, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-16.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Interior</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3">
                        <a href="javascript:void(0);">Interior Designing</a>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-04.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">John Doe</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>Detroit, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-17.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Car Wash</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3">
                        <a href="javascript:void(0);">Steam Car Wash</a>
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-05.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Hamilton</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>San Jose, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-18.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Electrical</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Electric Panel Repairing Service</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-06.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Blackwell</h6>
                            <span class="fs-12 text-truncate"
                              ><i class="ti ti-map-pin me-1"></i>San Francisco, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-19.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Cleaning</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >House Cleaning Services</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-07.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Wilson</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>Denver, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-20.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Painting</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Commercial Painting Services</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-08.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Clarence</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>Portland, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xxl-4 col-md-6">
                <div class="card p-0">
                  <div class="card-body p-0">
                    <div class="img-sec-2 w-100">
                      <router-link to="/details/service-details"
                        ><img
                          src="@/assets/img/providers/provider-22.jpg"
                          class="img-fluid rounded-top w-100"
                          alt="img"
                      /></router-link>
                      <div
                        class="image-tag d-flex justify-content-end align-items-center"
                      >
                        <a
                          href="javascript:void(0);"
                          class="like-icon d-flex justify-content-center align-items-center"
                          ><i class="ti ti-heart-filled filled"></i
                        ></a>
                        <span class="trend-tag-2">Construction</span>
                      </div>
                    </div>
                    <div class="img-content p-3">
                      <h6 class="fs-16 mb-3 text-truncate">
                        <router-link to="/details/service-details"
                          >Building Construction Services</router-link
                        >
                      </h6>
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <span class="avatar avatar-md me-2">
                            <img
                              src="@/assets/img/user/user-09.jpg"
                              class="rounded-circle"
                              alt="user"
                            />
                          </span>
                          <div>
                            <h6 class="fs-14">Roberts</h6>
                            <span class="fs-12"
                              ><i class="ti ti-map-pin me-1"></i>Houston, USA</span
                            >
                          </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center">
                          <router-link to="/details/service-details" class="btn btn-light btn-sm"
                            >View Details</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="value d-flex align-items-center">
                <span>Show</span>
                <select>
                  <option>7</option>
                </select>
                <span>entries</span>
              </div>
              <div class="d-flex align-items-center justify-content-center">
                <span class="me-2 text-gray-9">1 - 07 of 10</span>
                <nav aria-label="Page navigation">
                  <ul
                    class="paginations d-flex justify-content-center align-items-center"
                  >
                    <li class="page-item me-2">
                      <a
                        class="page-link-1 active d-flex justify-content-center align-items-center"
                        href="javascript:void(0);"
                        >1</a
                      >
                    </li>
                    <li class="page-item me-2">
                      <a
                        class="page-link-1 d-flex justify-content-center align-items-center"
                        href="javascript:void(0);"
                        >2</a
                      >
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link-1 d-flex justify-content-center align-items-center"
                        href="javascript:void(0);"
                        >3</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
